import HomeScene2 from './HomeScene2'
export default HomeScene2